import React, { useState, useEffect, useContext, useMemo } from "react";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import TextInput from "components/Input/TextInput.js";
import AddIcon from "@mui/icons-material/Add";
import {
  CustomSelect,
} from "components/Input/Index.js";
import uuid from "react-uuid";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import DataTable from "react-data-table-component";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import EditButton from "components/CustomButtons/Button.js";
import styled from "styled-components";
import { dico } from "variables/lists/dico";
import { campaigncharttext } from "variables/MBM/campaign";
import {
  chartsourceData, chartgranularityData, charttypeadvancedData, charttypepointData, chartseriesourceData,
  chartfixedvaluetypeData, chartaxisData, realestatevalueData
} from "variables/MBM/lists/campaign";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters.js";
import { Divider } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import CustomSwitch from "components/Input/CustomSwitch.js";
import FloatInput from "components/Input/FloatInput";
import TextInputUn from "components/Input/TextInputUn";
import FloatInputUn from "components/Input/FloatInputUn";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles2 = makeStyles(styles);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "0px",
    marginRight: "auto",
    marginLeft: "auto",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "0px",
    marginRight: "auto",
    marginLeft: "auto",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.1rem;
  font-weight: 400;

`;


function ChartDialogV2(props) {
  const { closeModal, charts, existingChartsData, currentchart, setCharts, points } = props;

  const [name, setName] = useState(currentchart?.name || "");
  const [type, setType] = useState(currentchart?.type || "");
  const [granularity, setGranularity] = useState(currentchart?.granularity || "");
  const [rightaxis, setRightaxis] = useState(currentchart?.rightaxis || false);
  const [leftaxisunit, setLeftaxisunit] = useState(currentchart?.leftaxisunit || "");
  const [rightaxisunit, setRightaxisunit] = useState(currentchart?.rightaxisunit || "");
  const [defaultoccupationschedule, setDefaultoccupationschedule] = useState(currentchart?.defaultoccupationschedule || false);

  const [series, setSeries] = useState(currentchart?.series || []);
  const [definitiondata, setDefinitiondata] = useState([]);

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleTypeChange = (event) => { setType(event.target.value); };
  const handleGranularityChange = (event) => { setGranularity(event.target.value); };
  const handleLeftaxisunitChange = (event) => { setLeftaxisunit(event.target.value); };
  const handleRightaxisChange = (event) => {
    setRightaxis(!rightaxis);
  };
  const handleRightaxisunitChange = (event) => { setRightaxisunit(event.target.value); };
  const handleDefaultoccupationscheduleChange = (event) => {
    setDefaultoccupationschedule(!defaultoccupationschedule);
  };

  const handleSerieNameChange = (event, serie) => {
    serie.name = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.name = event.target.value;
    setSeries(newseries);
  };
  const handleSourceChange = (event, serie) => {
    serie.source = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.source = event.target.value;
    setSeries(newseries);
  };
  const handlePointChange = (newValue, serie) => {
    serie.point = newValue;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.point = newValue;
    setSeries(newseries);
  };
  const handleDefinitionChange = (newValue, serie) => {
    serie.definition = newValue;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.definition = newValue;
    setSeries(newseries);
  };
  const handleAxisChange = (event, serie) => {
    serie.axis = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.axis = event.target.value;
    setSeries(newseries);
  };
  const handleValuetypeChange = (event, serie) => {
    serie.valuetype = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.valuetype = event.target.value;
    setSeries(newseries);
  };
  const handleValuefixedChange = (event, serie) => {
    serie.valuefixed = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.valuefixed = event.target.value;
    setSeries(newseries);
  };
  const handleValuerealestateChange = (event, serie) => {
    serie.valuerealestate = event.target.value;
    let newseries = [...series];
    let seriemodif = newseries.find((o) => o.uuid === serie.uuid);
    seriemodif.valuerealestate = event.target.value;
    setSeries(newseries);
  };
  useEffect(() => {
    let tmpdefinitiondata = dico.filter((item) =>
      points.find((x) => x.definition == item.id)
    );
    setDefinitiondata(tmpdefinitiondata);
  }, [points]);
  useEffect(() => {
    if (!rightaxis) {
      let newseries = [...series];
      newseries.forEach((serie) => {
        serie.axis = 'left';
      });
      setSeries(newseries);
    }
  }, [rightaxis]);

  const classes = useStyles();
  const classes2 = useStyles2();

  const handleSubmit = (event) => {
    if (currentchart?.id) {
      let chartstmp = [...charts];
      let updatedchart = chartstmp.find((x) => x.id === currentchart.id);

      updatedchart.name = name;
      updatedchart.type = type;
      updatedchart.granularity = granularity;
      updatedchart.series = series;
      updatedchart.leftaxisunit = leftaxisunit;
      updatedchart.rightaxis = rightaxis;
      updatedchart.rightaxisunit = rightaxisunit;
      updatedchart.defaultoccupationschedule = defaultoccupationschedule;
      setCharts(chartstmp);
    }
    else {
      let newchart = {};
      newchart.id = uuid();
      newchart.version = 'v2';
      newchart.source = 'created';
      newchart.name = name;
      newchart.type = type;
      newchart.granularity = granularity;
      newchart.series = series;
      newchart.leftaxisunit = leftaxisunit;
      newchart.rightaxis = rightaxis;
      newchart.rightaxisunit = rightaxisunit;
      newchart.defaultoccupationschedule = defaultoccupationschedule;

      let chartstmp = [...charts];
      newchart.position = chartstmp.length + 1;
      chartstmp.push(newchart);
      setCharts(chartstmp);
    }
    closeModal();
  };

  useEffect(() => {
    if ((!name || !type || !granularity))
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  }, [name, type, granularity]);

  const chartsColumns = [
    {
      name: campaigncharttext.position,
      selector: (row) => row.position,
      sortable: true,
      maxWidth: "6rem",
      cell: (row) => row.position,
    },
    {
      name: campaigncharttext.serietype,
      selector: (row) => row.source,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => row.source ? chartseriesourceData.find((a) => a.id == row.source)?.name || "" : ""
    },
    {
      name: campaigncharttext.seriename,
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => row.name
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Monter la position">
              <EditButton
                onClick={upSerie(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == 1}
              >
                <ArrowDropUpIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Descendre la position">
              <EditButton
                onClick={downSerie(row)}
                color={"info"}
                className={classes2.actionButton}
                disabled={row.position == series.length}
              >
                <ArrowDropDownIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title="Supprimer la série de la vue">
              <EditButton
                onClick={deleteSerieFromChartFunction(row)}
                color={"danger"}
                className={classes2.actionButton}
              >
                <DeleteIcon fontSize="large" />
              </EditButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ]

  const upSerie = (row) => async () => {
    let newseries = [...series];
    let obj = newseries.find((o) => o.uuid === row.uuid);
    let oldposition = obj.position;
    let newposition = oldposition - 1; //ie 3 -> 2
    let replacedserie = newseries.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedserie.position = oldposition;
    setSeries(newseries);
  }

  const downSerie = (row) => async () => {
    let newseries = [...series];
    let obj = newseries.find((o) => o.uuid === row.uuid);
    let oldposition = obj.position;
    let newposition = oldposition + 1; //ie 3 -> 4
    let replacedserie = newseries.find((o) => o.position === newposition);
    obj.position = newposition;
    replacedserie.position = oldposition;
    setSeries(newseries);
  }

  const deleteSerieFromChartFunction = (row) => async () => {
    let deletedposition = series.find((o) => o.uuid === row.uuid).position;

    let newseries = series.filter((o) => o.uuid !== row.uuid);
    console.log(deletedposition, newseries.length);
    for (let i = deletedposition + 1; i <= newseries.length + 1; i++) {
      let serie = newseries.find((o) => o.position === i);
      console.log(serie.position, i - 1);
      if (serie)
        serie.position = i - 1;
    }
    setSeries(newseries);
  };

  const addSerieToChartFunction = () => {
    console.log("add serie");
    let newseries = [...series];
    let newserie = {};
    newserie.uuid = uuid();
    newserie.name = "Nouvelle série";
    newserie.position = newseries.length + 1;
    newserie.axis = 'left';
    newseries.push(newserie);
    setSeries(newseries);
  }

  const ExpandableComponent = (props) => {
    const { data } = props;
    console.log(data);
    let serie = series.find((o) => o.uuid === data.uuid);
    let name = data.name;
    return (
      <>
        <div>

          <TextInputUn
            inputTitle={campaigncharttext.seriename}
            textInput={name}
            value={serie.name}
            handleTextInputChange={(event) => handleSerieNameChange(event, serie)}
          />
          {/* <TextInput
            inputTitle={campaigncharttext.seriename}
            textInput={name}
            value={serie.name}
            handleTextInputChange={(event) => handleSerieNameChange(event, serie)}
          /> */}
        </div>
        <div>
          <CustomSelect
            inputTitle={campaigncharttext.source}
            selectValue={serie.source}
            handleSelectValueChange={(event) => handleSourceChange(event, serie)}
            data={chartseriesourceData}
          />
        </div>
        <>
          {(serie.source === 'point') ?
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={campaigncharttext.point}
                selected={serie.point || {}}
                list={points}
                handleChange={(_, newValue) =>
                  handlePointChange(newValue, serie)
                }
              />
            </div> : <></>
          }
          {(serie.source === 'definition') ?
            <div>
              <AutocompleteInputMeters
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={campaigncharttext.definition}
                selected={serie.definition || {}}
                list={definitiondata}
                handleChange={(_, newValue) =>
                  handleDefinitionChange(newValue, serie)
                }
              />
            </div> : <></>
          }
          {(type !== 'tab' && rightaxis) ?
            <div>
              <CustomSelect
                inputTitle={campaigncharttext.axis}
                selectValue={serie.axis}
                handleSelectValueChange={(event) => handleAxisChange(event, serie)}
                data={chartaxisData}
              />
            </div>
            : <></>
          }
          {
            (serie.source === 'fixedvalue') ?
              <>
                <div>
                  <CustomSelect
                    inputTitle={campaigncharttext.valuetype}
                    selectValue={serie.valuetype}
                    handleSelectValueChange={(event) => handleValuetypeChange(event, serie)}
                    data={chartfixedvaluetypeData}
                  />
                </div>
                {
                  (serie.valuetype === 'fixed') ?
                    <div>
                      <FloatInputUn
                        inputTitle={campaigncharttext.value}
                        floatInput={serie.valuefixed}
                        handleFloatInputChange={(event) => handleValuefixedChange(event, serie)}
                      />
                    </div>
                    : (serie.valuetype === 'realestate') ?
                      <div>
                        <CustomSelect
                          inputTitle={campaigncharttext.value}
                          selectValue={serie.valuerealestate}
                          handleSelectValueChange={(event) => handleValuerealestateChange(event, serie)}
                          data={realestatevalueData}
                        />
                      </div> : <></>
                }
              </>
              : <></>
          }
          <div style={{ height: "1.1rem" }}></div>
        </>
      </>);
  };

  const [resetPaginationToggleChart, setResetPaginationToggleChart] = useState(false);
  const subHeaderComponentMemoChart = useMemo(() => {
    const handleClearChart = () => {
    };
    return (
      <>
        <TableName>Séries du graphique</TableName>
        <UploadButton type="button" onClick={handleClearChart}>
          <Tooltip title="Ajouter une série">
            <EditButton
              onClick={addSerieToChartFunction}
              color={"success"}
              className={classes2.actionButton}
              disabled={series.length > 9}
            >
              <AddIcon fontSize="large" />
            </EditButton>
          </Tooltip>
        </UploadButton>
      </>
    );
  }, [series]);



  return (
    <>
      <DialogContent dividers style={{ height: "90vh" }}>
        <form className={classes.root}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={5} lg={5}>
              <TableName>Paramètres du graphique</TableName>
              <div>
                <TextInput
                  inputTitle={campaigncharttext.name}
                  textInput={name}
                  handleTextInputChange={handleNameChange}
                />
              </div>
              <div>
                <CustomSelect
                  inputTitle={campaigncharttext.type}
                  selectValue={type}
                  handleSelectValueChange={handleTypeChange}
                  //  data={(source && source === 'point') ? charttypepointData : charttypefullData}
                  data={charttypeadvancedData}
                />
              </div>
              {
                (type && type !== 'tab' && type !== 'pie') &&
                <>
                  <div>
                    <CustomSelect
                      inputTitle={campaigncharttext.granularity}
                      selectValue={granularity}
                      handleSelectValueChange={handleGranularityChange}
                      data={chartgranularityData}
                    />
                  </div>
                  <div>
                    <TextInput
                      inputTitle={campaigncharttext.leftaxisunit}
                      textInput={leftaxisunit}
                      handleTextInputChange={handleLeftaxisunitChange}
                    />
                  </div>
                  <div>
                    <CustomSwitch
                      style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                      inputTitle={campaigncharttext.rightaxis}
                      checkedState={rightaxis}
                      handleSwitchChange={handleRightaxisChange}
                    />
                  </div>
                  {(rightaxis) &&
                    <div>
                      <TextInput
                        inputTitle={campaigncharttext.rightaxisunit}
                        textInput={rightaxisunit}
                        handleTextInputChange={handleRightaxisunitChange}
                      />
                    </div>}
                  <div>
                    <CustomSwitch
                      style={{ margin: "0.5rem 0rem 0.5rem 1rem" }}
                      inputTitle={campaigncharttext.defaultoccupationschedule}
                      checkedState={defaultoccupationschedule}
                      handleSwitchChange={handleDefaultoccupationscheduleChange}
                    />
                  </div>
                </>
              }


            </GridItem>

            <GridItem xs={12} sm={12} md={7} lg={7}>
              <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
                noDataComponent={<NoData>{"Aucune série"}</NoData>}
                noHeader={true}
                columns={chartsColumns}
                persistTableHead
                pagination
                subHeader
                data={series}
                paginationComponentOptions={{
                  noRowsPerPage: false,
                  rowsPerPageText: "Lignes par page",
                  rangeSeparatorText: "sur",
                  selectAllRowsItem: false,
                  selectAllRowsItemText: "Selectionner toutes les lignes",
                }}
                defaultPageSize={10}
                filterable={true}
                defaultSortFieldId={1}
                manual={true}
                paginationResetDefaultPage={setResetPaginationToggleChart}
                subHeaderComponent={subHeaderComponentMemoChart}
                expandOnRowClicked
                expandableRows
                expandableRowDisabled={(row) => row.disabled}
                expandableRowsComponent={ExpandableComponent}
              />

            </GridItem>
          </GridContainer>

        </form>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </DialogActions>
    </>
  );
}

export default ChartDialogV2;
